function renderProduct(product, container) {

  container.innerHTML = `
    <div class="home-look-card">

  <a
    href="${product.url}"
    class="home-look-product-link"
  >

    <img
      class="home-look-card-image"
      src="${product.featured_image}"
      alt="${product.title}"
    >

  </a>

  <div class="home-look-card-info">

    <a
      href="${product.url}"
      class="home-look-product-link"
    >

      <h3 class="home-look-card-title">
        ${product.title}
      </h3>

    </a>

        <div class="home-look-card-price">

  ${
    product.compare_at_price > product.price
      ? `
        <span class="home-look-sale-price">
          ${(product.price / 100).toFixed(2)} €
        </span>

        <span class="home-look-compare-price">
          ${(product.compare_at_price / 100).toFixed(2)} €
        </span>
      `
      : `
        <span class="home-look-sale-price">
          ${(product.price / 100).toFixed(2)} €
        </span>
      `
  }

</div>

        <div class="home-look-label">
          Seleccione una talla
        </div>

        <div class="home-look-sizes">

          ${product.variants.map(variant => `
            <button
              class="home-look-size"
              data-variant-id="${variant.id}"
              ${variant.available ? '' : 'disabled'}
            >
              ${variant.option1}
            </button>
          `).join('')}

        </div>

      </div>

    </div>
  `;

  const sizeButtons = container.querySelectorAll('.home-look-size');

  sizeButtons.forEach(button => {

    button.addEventListener('click', () => {

      container.querySelectorAll('.home-look-size').forEach(btn => {
        btn.classList.remove('selected');
      });

      button.classList.add('selected');

      // Guardamos la variante seleccionada
      container.dataset.selectedVariant = button.dataset.variantId;

      // Guardamos también el precio de esa variante
      const variant = product.variants.find(
        v => v.id == button.dataset.variantId
      );

      container.dataset.selectedPrice = variant.price;

      // Actualizamos el importe total
      updateTotal();

      const selected1 = document.getElementById('home-look-product-1').dataset.selectedVariant;
      const selected2 = document.getElementById('home-look-product-2').dataset.selectedVariant;

      const addButton = document.getElementById('home-look-add');

      if (addButton) {
        addButton.disabled = !(selected1 && selected2);
      }

    });

  });

}

// =========================
// ACTUALIZAR IMPORTE TOTAL
// =========================

function updateTotal() {

  const product1 = document.getElementById('home-look-product-1');
  const product2 = document.getElementById('home-look-product-2');

  const totalElement = document.getElementById('home-look-total-price');

  let total = 0;

  if (product1.dataset.selectedPrice) {
    total += Number(product1.dataset.selectedPrice);
  }

  if (product2.dataset.selectedPrice) {
    total += Number(product2.dataset.selectedPrice);
  }

  totalElement.textContent =
    (total / 100).toFixed(2).replace('.', ',') + ' €';

}

document.addEventListener('DOMContentLoaded', () => {

  const drawer = document.getElementById('home-look-drawer');
  const close = document.getElementById('home-look-close');
  const addButton = document.getElementById('home-look-add');

  if (!drawer || !close) return;

  document.querySelectorAll('.shop-the-look__item').forEach(item => {

    item.addEventListener('click', async () => {

      const dialog = drawer.querySelector('dialog');

if (dialog && !dialog.open) {

  dialog.showModal();

  dialog.addEventListener('click', (e) => {

  if (e.target === dialog) {
    closeDrawer();
  }

});

document.body.style.overflow = 'hidden';
document.documentElement.style.overflow = 'hidden';

requestAnimationFrame(() => {
  drawer.setAttribute('open', '');
});

}

      // Reiniciamos botón
      document.getElementById('home-look-add').disabled = true;

      // Reiniciamos variantes
      document.getElementById('home-look-product-1').dataset.selectedVariant = '';
      document.getElementById('home-look-product-2').dataset.selectedVariant = '';

      // Reiniciamos precios
      document.getElementById('home-look-product-1').dataset.selectedPrice = '';
      document.getElementById('home-look-product-2').dataset.selectedPrice = '';

      // Reiniciamos importe
      updateTotal();

      const handle1 = item.getAttribute('data-product-1');
      const handle2 = item.getAttribute('data-product-2');

      const product1 = await fetch(`/products/${handle1}.js`)
        .then(res => res.json());

      const product2 = await fetch(`/products/${handle2}.js`)
        .then(res => res.json());

      renderProduct(
        product1,
        document.getElementById('home-look-product-1')
      );

      renderProduct(
        product2,
        document.getElementById('home-look-product-2')
      );

    });

  });

  function closeDrawer() {

  const dialog = drawer.querySelector('dialog');

  drawer.removeAttribute('open');

  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';

  setTimeout(() => {

    if (dialog && dialog.open) {
      dialog.close();
    }

  },220);

}

  addButton.addEventListener('click', async () => {

    const variant1 = document.getElementById('home-look-product-1').dataset.selectedVariant;
    const variant2 = document.getElementById('home-look-product-2').dataset.selectedVariant;

    if (!variant1 || !variant2) return;

    addButton.disabled = true;
    addButton.textContent = 'AÑADIENDO...';

    try {

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variant1),
              quantity: 1
            },
            {
              id: Number(variant2),
              quantity: 1
            }
          ]
        })
      });

      closeDrawer();

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:open'));

    } catch (error) {

      alert('Ha ocurrido un error al añadir el look.');

    }

    addButton.textContent = 'AÑADIR LOOK AL CARRITO';
    addButton.disabled = false;

  });

  close.addEventListener('click', closeDrawer);

});